import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';
import { renderCellByDelimiter } from '../../../../utils/renderCellByDelimiter';
const columns = (renderCell, runDetailsUnit, currentUnit, renderTargetsEditAction) => {
  return [
    {
      field: 'hole_depth',
      headerName: `Hole Depth (${runDetailsUnit?.hole_depth?.label})`,
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(runDetailsUnit?.hole_depth?.decimals);
      },
    },
    {
      field: 'bit_depth_offset',
      headerName: `Bit Off-Bottom Offset (${runDetailsUnit?.bit_depth_offset?.label})`,
      flex: 1,
      minWidth: 250,
      maxWidth: 350,
      renderEditCell: renderCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(runDetailsUnit?.bit_depth_offset?.decimals);
      },
    },
    {
      field: 'rpm',
      headerName: `RPM (${runDetailsUnit?.rpm?.label})`,
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(runDetailsUnit?.rpm?.decimals);
      },
    },
    {
      field: 'flow_in',
      headerName: `Flow Rate (${runDetailsUnit?.flow_in?.label})`,
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(runDetailsUnit?.flow_in?.decimals);
      },
    },
    {
      field: 'sbp',
      headerName: `SBP (${runDetailsUnit?.sbp?.label})`,
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(runDetailsUnit?.sbp?.decimals);
      },
    },
    {
      field: 'drillStringsId',
      headerName: 'Drillstrings',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderCell: renderCellByDelimiter,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'drillFluidsId',
      headerName: 'Drilling Fluids',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderCell: renderCellByDelimiter,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'target',
      headerName: 'Target',
      flex: 1,
      minWidth: 200,
      maxWidth: 300,
      renderCell: renderTargetsEditAction,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};
const strippingTableColumns = (renderValueCell, renderActions, strippingUnit, unit, renderTripPipeTypeCell, renderReportEveryCell, renderCell) => [
  {
    field: 'runNumber',
    headerName: 'Run',
    headerAlign: 'center',
    align: 'center',
    renderCell,
  },
  {
    field: 'from',
    headerName: `From MD (${strippingUnit?.from?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.from.decimals);
    },
  },
  {
    field: 'to',
    headerName: `To MD (${strippingUnit?.to?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.to.decimals);
    },
  },
  {
    field: 'speed',
    headerName: `Trip Speed (${strippingUnit?.speed?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.speed.decimals);
    },
  },
  {
    field: 'tubular',
    headerName: 'Tubular',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderTripPipeTypeCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'report_interval',
    headerName: `Intervals (${strippingUnit?.report_interval?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderReportEveryCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.report_interval.decimals);
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];
export { columns, strippingTableColumns };
